module.exports = __webpack_public_path__ + "28b67065/img/grid-web-icon.d0395d64.svg";